<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
  export default {
    name: 'App',
    components: {},
    data() {
      return {}
    },
    mounted() {
      window.addEventListener('unload', this.saveState)
    },
    methods: {
      saveState() {
        sessionStorage.setItem('state', JSON.stringify(this.$store.state))
      }
    }
  }
</script>
<style>
  html, body {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    font-size:calc(100vw / 7.5);
    font-family: PingFangSC;
  }

  #app {
    width: 100%;
    height: 100%;
  }
</style>
